import { useEffect } from 'react';

import useLocalSettings from '@/stores/useLocalSettings';

import extractFontStyle from '../outlook/extractFontStyle';
import getBody from '../outlook/getBody';
import isComposeMode from '../outlook/isComposeMode';

export default function useRememberComposeFont() {
  useEffect(() => {
    const rememberComposeFont = async () => {
      try {
        await Office.onReady();
        if (!isComposeMode()) return;

        const detectedStyle = extractFontStyle(await getBody('Html'));
        const cachedStyle = useLocalSettings.getState().composeFontStyle;

        if (detectedStyle && detectedStyle !== cachedStyle)
          useLocalSettings
            .getState()
            .actions.setComposeFontStyle(detectedStyle);
      } catch {
        return;
      }
    };

    rememberComposeFont();
  }, []);
}
